import { APIClient } from "@heidelbergmaterials/fcl-apiclient"

import { useBaseApiClient } from "./useBaseApiClient"

export const legalUrl = import.meta.env.VITE_LEGAL_API

/**
 * Custom hook to get Legal API client without authentication or interceptors
 *
 * This hook creates an APIClient instance for the Legal API (VITE_LEGAL_API)
 * without authentication or custom interceptors, as legal documents are public.
 *
 * @returns APIClient instance configured for Legal API
 *
 * @example
 * ```tsx
 * import { useLegalClient } from '@shared/api/client/useLegalClient'
 *
 * const MyComponent = () => {
 *   const legalClient = useLegalClient()
 *
 *   const fetchTerms = async () => {
 *     const response = await legalClient.get('/terms')
 *     return response.data
 *   }
 * }
 * ```
 */
export const useLegalClient = (): APIClient => {
	return useBaseApiClient({
		baseURL: legalUrl,
		authFlow: null,
		useInterceptors: false,
	})
}
